import { render, staticRenderFns } from "./PartnershipManagerCreate.vue?vue&type=template&id=09afd3b7&"
import script from "./PartnershipManagerCreate.vue?vue&type=script&lang=js&"
export * from "./PartnershipManagerCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports